<template>
  <div ref="chart" style="width: 100%; height: 100%"></div>
</template>

<script>
import china from "@/assets/china1.json";

export default {
  name: "Map",
  props: { wdSize: Object, id: Number },
  computed: {},
  watch: {
    id() {
      this.setData();
    },
    option: {
      deep: true,
      handler: function (n, o) {
        this.chart.setOption(this.option);
      },
    },
    wdSize(n, o) {
      if (this.chart) {
        this.chart.resize();
        setTimeout(() => {
          this.chart.resize();
        }, 10);
      }
    },
  },
  // created() {
  //
  // },
  data() {
    return {
      chart: null,
      option: {
        backgroundColor: "transparent",
        title: {
          text: "游客来源分布图",
          subtext: "Tourist Source Distribution Map",
          // sublink: '',
          left: "center",
          textStyle: {
            color: "#fff",
          },
        },
        tooltip: {
          trigger: "item",
        },
        visualMap: {
          min: 0,
          max: 200,
          text: ["High", "Low"],
          realtime: false,
          calculable: true,
          inRange: {
            color: ["lightskyblue", "yellow", "orangered"],
          },
        },
        series: [
          {
            name: "",
            type: "map",
            map: "china",
            geoIndx: 0,
            aspectScale: 0.75,
            showLegendSymbol: false,

            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: true,
                textStyle: {
                  color: "#fff",
                },
              },
            },
            roam: false,
            zoom: 1.2,
            animation: false,
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    resize() {
      // if (this.chart) {
      this.chart.resize();
      // }
    },
    setData() {
      this.$axios({
        method: "get",
        url: "/getFlowMap?id=" + this.id,
      }).then((r) => {
        this.option.series[0].data = r.data;
        this.chart.setOption(this.option);
      });
    },
    mapClick(name) {},
  },
  mounted() {
    this.$nextTick(() => {
      this.chart = this.$echarts.init(this.$refs.chart, null);
      this.$echarts.registerMap("china", china);
      let t = this;
      this.chart.on("click", function (p) {
        t.mapClick(p.name);
      });
      this.setData();
    });
  },
};
</script>

<style scoped></style>
